import { intervalToDuration } from "date-fns";
import _ from "lodash";

export const renderDuration = (
  translate,
  timeStart,
  timeEnd,
  useShortNotations
) => {
  const FIXED_START_DATE = "01/01/2021";
  const FIXED_END_DATE = "01/02/2021";

  const message = (type, val) => {
    if (useShortNotations) {
      return val ? `${val}${translate(`${type}_short`)}` : "";
    }

    return val ? `${translate(type, { total: val })}` : "";
  };

  const startDate = new Date(`${FIXED_START_DATE} ${timeStart}`);
  const endDate = new Date(`${FIXED_END_DATE} ${timeEnd}`);

  const duration = intervalToDuration({
    start: startDate,
    end: endDate,
  });

  let hours;
  let minutes;

  if (duration.days === 1 && duration.hours === 0 && duration.minutes === 0) {
    hours = message("hours", 24);
  } else {
    hours = message("hours", duration.hours);
    minutes = message("minutes", duration.minutes);
  }

  const joined = _.join(_.compact([hours, minutes]), " ");

  return `(${joined})`;
};
